import { Input } from "@/components/input";
import { Label } from "@/components/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/select";
import { Switch } from "@/components/switch";
import type { DocumentNode, NodeData } from "@repo/shared/workflow";
import type { FC } from "react";

interface DocumentNodeEditorProps {
  node: DocumentNode;
  onChange: (key: string, value: any) => void;
}

export const DocumentNodeEditor: FC<DocumentNodeEditorProps> = ({
  node,
  onChange,
}) => {
  const { documentType, required, acceptMultiple, skipIngestion } = node;

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="documentType">Document Type</Label>
        <Select
          value={documentType || "pdf"}
          onValueChange={(value) => onChange("documentType", value)}
        >
          <SelectTrigger id="documentType">
            <SelectValue placeholder="Select document type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="pdf">PDF</SelectItem>
            <SelectItem value="xlsx">Excel</SelectItem>
            <SelectItem value="csv">CSV</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center space-x-2 py-2">
        <Switch
          id="required"
          checked={required !== false}
          onCheckedChange={(checked) => onChange("required", checked)}
        />
        <Label htmlFor="required">Required</Label>
      </div>

      <div className="flex items-center space-x-2 py-2">
        <Switch
          id="acceptMultiple"
          checked={acceptMultiple === true}
          onCheckedChange={(checked) => onChange("acceptMultiple", checked)}
        />
        <Label htmlFor="acceptMultiple">Accept Multiple Documents</Label>
      </div>

      <div className="flex items-center space-x-2 py-2">
        <Switch
          id="skipIngestion"
          checked={skipIngestion === true}
          onCheckedChange={(checked) => onChange("skipIngestion", checked)}
        />
        <Label htmlFor="skipIngestion">Skip Ingestion</Label>
      </div>

      <div className="space-y-2">
        <Label htmlFor="exampleDocumentId">Example Document ID</Label>
        <Input
          id="exampleDocumentId"
          value={node.exampleDocumentId || ""}
          onChange={(e) => onChange("exampleDocumentId", e.target.value)}
          placeholder="Optional example document ID"
        />
      </div>
    </div>
  );
};
